<template>
  <div>
    <div v-if="part === 1">
      <h2>{{ $t('SAAI.Result.title') }}</h2>
      <br />
      <p>{{ $t('SAAI.Result.explanation') }}</p>
    </div>
    <div v-if="part === 2">
      <h2>{{ $t('SAAI.Result.ResultDetail.title') }}</h2>
    </div>
    <ResultTable
      v-if="part === 1"
      @updateSelectedResultId="updateSelectedResultId"
      @updateSelectedCreatedAt="updateSelectedCreatedAt"
    />
    <ResultDetailTable
      v-if="part === 2"
      :selectedResultId="selectedResultId"
      :createdAt="createdAt"
      @setPapersDetailList="setPapersDetailList"
      @setQuestions="setQuestions"
      @setSelectedWordList="setSelectedWordList"
    />
    <div class="result-control flex-row flex-right">
      <div class="button-wrapper" id="result-button-wrapper">
        <button v-if="part === 1" @click="movePage">{{ $t('SAAI.Result.next') }}</button>
        <button v-else @click="movePage">{{ $t('SAAI.Result.before') }}</button>
        <button v-if="part === 2" @click="downloadXlsxData">
          {{ $t('SAAI.Result.download') }}
        </button>
      </div>
    </div>
    <Modal v-if="isShow" />
  </div>
</template>

<script>
import ResultTable from '@/components/Saai/Result/ResultTable.vue';
import ResultDetailTable from '@/components/Saai/Result/ResultDetailTable.vue';
import Modal from '@/components/Modal.vue';
import { mapActions, mapState } from 'vuex';
import { fileDownloadSaai } from '@/modules/fileController';

export default {
  components: {
    ResultTable,
    ResultDetailTable,
    Modal,
  },
  data() {
    return {
      part: 1,
      selectedResultId: 0,
      downloadData: [],
      mergedExcelRow: [],
      createdAt: '',
      papersDetailList: [],
      questions: [],
      selectedWordList: [],
    };
  },
  methods: {
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    modalOpener() {
      const content =
        this.$i18n.locale === 'eng' ? 'No assessments selected.' : '선택된 평가지가 없습니다.';
      this.AC_MODAL_OPEN({
        content: content,
      });
    },
    checkSelectedResultId() {
      this.selectedResultId > 0 ? (this.part += 1) : this.modalOpener();
    },
    updateSelectedResultId(number) {
      this.selectedResultId = number;
    },
    updateSelectedCreatedAt(createdAt) {
      this.createdAt = createdAt;
    },
    movePage() {
      if (this.part === 1) {
        this.checkSelectedResultId();
      } else {
        this.part -= 1;
        this.updateSelectedResultId(0);
      }
    },
    setPapersDetailList(papersDetailList) {
      this.papersDetailList = papersDetailList;
    },
    setQuestions(questions) {
      this.questions = questions;
    },
    setSelectedWordList(selectedWordList) {
      this.selectedWordList = selectedWordList;
    },
    downloadXlsxData() {
      const deepCopy = require('lodash');
      let excelResults = deepCopy.cloneDeep(this.papersDetailList.slice());

      for (const page in excelResults) {
        const pageImportantWord = this.selectedWordList[page];
        for (const answer of excelResults[page]) {
          const missingKeywords = answer.missing_keywords.split(', ');
          if (pageImportantWord.length > 0) {
            missingKeywords = missingKeywords.filter((element) =>
              pageImportantWord.includes(element)
            );
            answer.missing_keywords = missingKeywords.join(', ');
          } else {
            answer.missing_keywords = '';
          }
        }
      }
      fileDownloadSaai(excelResults, this.questions, false, this.$i18n.locale);
    },
  },
  computed: {
    ...mapState('modal', ['isShow']),
    ...mapState('login', ['isLogin']),
  },
  created() {
    if (!this.isLogin) {
      const content =
        this.$i18n.locale === 'eng' ? 'Please sign in to use.' : '로그인이 필요한 서비스입니다.';
      const url = '/login';
      this.AC_MODAL_OPEN({
        content: content,
        url: url,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.result-control {
  max-width: 1200px;
  align-items: flex-end;
  margin: 20px auto;
}
.button-wrapper {
  margin: 0;
  justify-content: right !important;
}

.flex-right {
  justify-content: right;
}
</style>
